<template>
  <PageForm action="create" :model="model"/>
</template>

<script>
import PageForm from '@/components/Utils/PageForm'
import Page from '@/model/Page'

export default {
  components: {
    PageForm
  },
  computed: {
    model () {
      return Page
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/page/Create.vue